// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pendingOrderSticky {\n  position: sticky;\n  top: 20px;\n  background-color: #f1f1f1;\n}\n.pendingOrderScrollable {\n  overflow-y: auto;\n  height: calc(100vh - 80px);\n}\n.pendingOrderScrollable::-webkit-scrollbar {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
